module.exports = __webpack_public_path__ + "img/episode9.aa0fa372.png";